/* global WebViewJavascriptBridge */
import deviceInfo from './deviceInfo'
import store from '../store'
import statisticHelper from './statisticalHelper'
import channelHelper from './channel'
import Vue from 'vue'
import router from '../router'
import GlobalHelper from './globalHelper'
const setupWebViewJavascriptBridge = callback => {
  // 注册事件监听
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge)
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', () => {
      callback(WebViewJavascriptBridge)
    }, false)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  let WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

export default {
  showLog(log) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('showLog', log, function responseCallback(responseData) {
      })
    })
  },
  // 获取原生设备信息
  fetchDeviceInfo() {
    if (deviceInfo.isAndroidDevice()) {
      if (window.android && window.android.fetchDeviceInfo()) {
        let responseData = window.android.fetchDeviceInfo()
        deviceInfo.saveDeviceInfo(responseData)
      }
    } else {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('kJSFetchDeviceInfo', function (responseData) {
          deviceInfo.saveDeviceInfo(responseData)
        })
      })
    }
  },
  // 获取原生设备信息
  fetchDeviceInfoBak(callback) {
    if (deviceInfo.isAndroidDevice()) {
      if (window.android && window.android.fetchDeviceInfo()) {
        let responseData = window.android.fetchDeviceInfo()
        deviceInfo.saveDeviceInfo(responseData)
        callback()
      }
    } else {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('kJSFetchDeviceInfo', function (responseData) {
          deviceInfo.saveDeviceInfo(responseData)
          callback()
        })
      })
    }
  },
  // 回传页面链接至原生
  sendApplyPageUrlToNative() {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSFetchApplyURL', window.location.href, function responseCallback(responseData) {
      })
    })
  },
  // 回传页面信息至原生
  sendApplyPageInfoToNative(info) {
    if (window.native && window.native.kJSFetchProductInfo) {
      window.native.kJSFetchProductInfo(JSON.stringify(info))
    }
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSFetchProductInfo', info, function responseCallback(responseData) {
      })
    })
  },
  // IOS回传页面信息至原生
  sendIosApplyPageInfoToNative(info) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSIosFetchProductInfo', info, function responseCallback(responseData) {
      })
    })
  },
  // 每次启动app时清除之前的登录状态
  logoutWhenAppLaunch() {
    // for android
    window.forceLogoutWhenAppLaunch = function () {
      // store.dispatch('logout')
      // 首次进入app，默认统计第一个按钮点击事件
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('kJSAppLaunch', function (data) {
        // store.dispatch('logout')
        // 首次进入app，默认统计第一个按钮点击事件
      })
    })
    if (!channelHelper.isApp() && !GlobalHelper.hasProjectEntered()) {
    }
  },
  // 隐藏原生启动页
  hideNativeLaunchImage() {
    // for android
    if (window.appNative && window.appNative.hideLaunchView) {
      window.appNative.hideLaunchView()
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSHideLaunchImage', function responseCallback(responseData) {
      })
    })
  },
  // 隐藏显示原生header
  showAndHideNativeHeader(show) {
    // 解决每次从第三方返回时弹出营销弹窗的问题
    if (show) {
      window.localStorage.setItem('isShowPopup', 'true')
    }
    // for android
    if (window.native && window.native.showHeader) {
      window.native.showHeader(show)
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSShowAndHideNativeHeader', show, function responseCallback(responseData) {
      })
    })
  },
  // 打开微信
  openWX() {
    // for android
    if (window.native && window.native.openWX) {
      window.native.openWX()
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSOpenWeixin', function responseCallback(responseData) {
      })
    })
  },
  // 检查定位权限是否打开
  checkUserAuthorization(callback) {
    // for android
    if (deviceInfo.isAndroidDevice()) {
      if (window.native && window.native.checkUserAuthorization) {
        let isOpen = window.native.checkUserAuthorization()
        if (isOpen && isOpen === 'true') {
          callback(true)
        } else {
          callback(false)
        }
      } else {
        callback(true)
      }
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSCheckUserAuthorization', function responseCallback(responseData) {
        if (responseData && responseData === 'true') {
          callback(true)
        } else {
          callback(false)
        }
      })
    })
  },
  dealJPushInfo() {
    /* receive jPush id */
    // for android
    window.fetchJPushID = function (data) {
      store.dispatch('saveJPushID', data)
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('kFetchJPushId', function (data) {
        store.dispatch('saveJPushID', data)
      })
    })
    /* receive jPush info */
    function dealPushInfo(data) {
      let pushInfo = JSON.parse(data)
      if (pushInfo) {
        router.push({name: 'LoanProduct'})
        if (pushInfo.openType === '1') {
          if (pushInfo.jumpCommand === '1') {
            window.setTimeout(function () {
              router.push({name: 'ProductDetail', params: {productInfo: data}})
            }, 200)
          }
        } else {
          window.setTimeout(function () {
            window.location.href = pushInfo.openUrl
            this.showAndHideNativeHeader(true)
          }, 200)
        }
      }
    }

    // for android
    window.dealJPushInfo = function (data) {
      dealPushInfo(data)
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('kDealPushInfo', function (data) {
        dealPushInfo(data)
      })
    })
  },
  dealLaunchInfo(callback) {
    let that = this;
    function dealInfo(data) {
      let productInfo = JSON.parse(data)
      callback(productInfo['jumpType'])
      if (data.indexOf('url') !== -1) {
        statisticHelper.announcementEventStatistical('ad_kp', '开屏广告', 'ad_kp', productInfo['id'] ? productInfo.id : 'nosign', 'nosign', productInfo.url)
        window.setTimeout(function () {
          let url = productInfo.url
          if (store.getters.isLogin && productInfo.url.indexOf('activity.xycredit.com.cn') !== -1) {
            url += `&bannerPhone=${store.getters.phone}&bannerUserId=${store.state.user.userInfo.id}`
          }
          window.location.href = url
          that.showAndHideNativeHeader(true)
          // ios
          that.sendApplyPageUrlToNative()
          // android
          if (window.android && window.android.callAndroid) {
            window.android.callAndroid(window.location.href, that.title, {})
          }
        }, 800)
      } else if (productInfo['jumpType'] === 'insurance') {
        statisticHelper.announcementEventStatistical('ad_kp', '开屏广告', 'ad_kp', productInfo['id'] ? productInfo.id : 'nosign', 'nosign', 'nosign')
        router.push({name: 'Insurance'})
      } else if (productInfo['jumpType'] === 'Position') {
        statisticHelper.announcementEventStatistical('ad_kp', '开屏广告', 'ad_kp', productInfo['id'] ? productInfo.id : 'nosign', 'nosign', 'nosign')
        let prodIDs = productInfo.prodIds
        router.push({name: 'ZlProductList', params: {prodIDs: prodIDs}})
      } else if (productInfo['jumpType'] === 'closeAd') {
        statisticHelper.announcementEventStatistical('ad_kp', '开屏广告', 'pass', 'notrack', 'notrack', 'notrack')
      } else {
        statisticHelper.announcementEventStatistical('ad_kp', '开屏广告', 'ad_kp', productInfo['id'] ? productInfo.id : 'nosign', 'nosign', 'nosign')
        router.push({name: 'ProductDetail', params: {productInfo: data}, query: {resource: 'kpgg'}})
      }
    }
    // for android
    window.dealLaunchInfo = function (data) {
      dealInfo(data)
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('kDealLaunchInfo', function (data) {
        dealInfo(data)
      })
    })
  },
  handleFriendShare(data) {
    // for android
    if (deviceInfo.isAndroidDevice()) {
      if (window.native && window.native.handleFriendShare) {
        window.native.handleFriendShare(data)
      }
    }
    // for iOS
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('handleFriendShare', data, function responseCallback(responseData) {
      })
    })
  },
  takePhoto(callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSTakePhoto', function responseCallback(responseData) {
        callback(responseData)
      })
    })
  },
  // 点点人脸识别
  faceDetect(func) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('faceDetect', null, func)
    })
  },
  // 检测原生权限 location,camera,notification,microphone
  checkNativePermissionState(type, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('checkNativePermissionState', type, data => {
        callback(data)
      });
    })
  },
  // 进入原生设置界面
  enterNativeSettingPage() {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('enterNativeSettingPage', undefined, data => {
      });
    })
  },
  // 获取通讯录
  fetchContacts(func) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kFetchContacts', null, func)
    })
  },
  // 检查通讯录权限
  checkContactsAuthority(func) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kCheckContactsAuth', null, func)
    })
  },
  // 打开通讯录授权页面
  openContactsSetting() {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kOpenContactsSetting', null, function () {
      })
    })
  },
  // 调用关闭当前webView
  closeNativePage() {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('closeNativePage', null, function () {
      })
    })
  },
  // 回传登录和实名信息至原生
  sendLoginInfoToNative(info) {
    let that = this
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSFetchLoginInfo', info, function responseCallback() {
        if (channelHelper.isIosCheck()) that.closeNativePage()
      })
    })
  },
  // 退出原生
  loginOutToNative() {
    setupWebViewJavascriptBridge(function (bridge) {
      if (deviceInfo.isAndroidDevice()) {
        bridge.callHandler('kJSLoginOut', function responseCallback() {
        })
      }
    })
  },
  // IOS/安卓从第三方返回后通知H5主动调用接收原生回传数据的方法
  handleMsgAdInfo(func) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('kDealLaunchUserInfo', func)
    })
  },
  // IOS/安卓回传登录后数据
  fetchUserInfo() {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kFetchUserInfo', null, function responseCallback(res) {
        // 若原生传递的对象中有用户登录信息，则读取为已登录用户，否则为未登录用户
        if (res && JSON.parse(res).body['sessionId']) {
          let response = JSON.parse(res)
          store.dispatch('saveUserInfo', response)
          // 将用户的登陆信息 sessionId 写入cookie
          document.cookie = `JSESSIONID=${response.body.sessionId}; path=/;`
        } else {
          // store.dispatch('clearUserInfoAndLogOutTag')
          // if ('userPhone' in response) {
          //   localStorage.setItem('userMsg', response['userPhone'])
          // } else {
          //   localStorage.removeItem('userMsg')
          // }
        }
      })
    })
  },
  // 检查相机、定位、通讯录等权限是否打开
  checkUserPhotoAuthorization(callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler('kJSCheckPermissions', function responseCallback(responseData) {
        if (responseData && responseData === 'true') {
          callback(true)
        } else {
          callback(false)
        }
      })
    })
  },
  // 解决Android点申请跳转第三方后点击返回按钮返回详情页调用jsbridge方法失败的问题
  nativeCallbak(info) {
    // for android
    if (window.native && window.native.kJSCheckPermissions) {
      window.native.kJSCheckPermissions(info)
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/jsBridge.js